import { render, staticRenderFns } from "./NewBulkDelete.vue?vue&type=template&id=754bec44&scoped=true"
import script from "./NewBulkDelete.vue?vue&type=script&lang=js"
export * from "./NewBulkDelete.vue?vue&type=script&lang=js"
import style0 from "./NewBulkDelete.vue?vue&type=style&index=0&id=754bec44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754bec44",
  null
  
)

export default component.exports